import request from '@/utils/request'


//查询任务设置
export function queryGoods(data) {
  return request({
    url: '/admin/goods/search',
    method: 'post',
    data: data
  })
}

export function addGoods(data) {
  return request({
    url: '/admin/goods/addGoods',
    method: 'post',
    data: data
  })
}

export function delGoods(params) {
  return request({
    url: '/admin/goods/deleteGoods',
    method: 'get',
    params: params
  })
}

export function updateGoods(data) {
  return request({
    url: '/admin/goods/updateGoods',
    method: 'post',
    data: data
  })
}


// WEBPACK FOOTER //
// ./src/api/Goods.js